module.exports = "<div mat-dialog-content style=\"text-align: center\">\r\n    <p>{{ data.name }}</p>\r\n</div>"